import React from "react";

const TableBlock = ({ block }) => {
    const headers = block.headers || [];
    const rows = block.rows || [];

    return (
        <div
            style={{
                overflowX: "auto",
                margin: "20px 0",
            }}
        >
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                }}
            >
                <thead>
                    <tr>
                        {headers.map((header, index) => (
                            <th
                                key={index}
                                style={{
                                    border: "1px solid #111",
                                    padding: 8,
                                    textAlign: "left",
                                }}
                            >
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {rows.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {row.map((cell, cellIndex) => (
                                <td
                                    key={cellIndex}
                                    style={{
                                        border: "1px solid #111",
                                        padding: 8,
                                    }}
                                >
                                    {cell}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableBlock;